/** Soglia unica mobile Panify: allineata a Bootstrap `lg` e ad App.js. */
export const MOBILE_MAX_WIDTH = 992;

export const isMobileViewport = () =>
  typeof window !== 'undefined' && window.innerWidth < MOBILE_MAX_WIDTH;
